export default __webpack_public_path__ + "static/char-47-e04fbc86c8227a7e3360fc96ce816845.webp";